export function getRandomInt ( min, max ) {
    const _min = Math.ceil( min );
    const _max = Math.floor( max );
    return Math.floor( Math.random() * ( _max - _min + 1 ) ) + _min;
}

export function pad ( number, width, z = '0' ) {
    const n = number.toString();
    return n.length >= width ? n : new Array( width - n.length + 1 ).join( z ) + n;
}

export function wait ( ms ) {
    return new Promise(( r, j ) => setTimeout( r, ms ));
}
